import React from "react";

const Camera = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M13.2 3h9.6L26 6.26h6.4c.424 0 .831.171 1.131.477.3.305.469.72.469 1.152v22.815c0 .432-.169.846-.469 1.152-.3.306-.707.477-1.131.477H3.6c-.424 0-.831-.171-1.131-.477-.3-.306-.469-.72-.469-1.152V7.889c0-.432.169-.847.469-1.152.3-.306.707-.478 1.131-.478H10L13.2 3ZM18 29.074a9.512 9.512 0 0 0 6.788-2.864 9.87 9.87 0 0 0 2.812-6.914 9.87 9.87 0 0 0-2.812-6.914A9.512 9.512 0 0 0 18 9.52a9.512 9.512 0 0 0-6.788 2.863A9.87 9.87 0 0 0 8.4 19.296a9.87 9.87 0 0 0 2.812 6.914A9.512 9.512 0 0 0 18 29.074Zm0-3.26a6.342 6.342 0 0 1-4.525-1.908 6.58 6.58 0 0 1-1.875-4.61 6.58 6.58 0 0 1 1.875-4.609A6.341 6.341 0 0 1 18 12.777c1.697 0 3.325.688 4.526 1.91a6.58 6.58 0 0 1 1.874 4.61 6.58 6.58 0 0 1-1.874 4.609A6.342 6.342 0 0 1 18 25.815Z"
            fill={fill}
        />
    </svg>
);

export default Camera;